import { render, staticRenderFns } from "./ClassicDashboard.vue?vue&type=template&id=e5925c8c&"
import script from "./ClassicDashboard.vue?vue&type=script&lang=js&"
export * from "./ClassicDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports